import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faLock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { API_URL } from '../config';
import { useNavigate, useParams } from 'react-router-dom';
import Header from './component/Header';
import PublicFooter from '../components/layout/PublicFooter';
import StaticPageLayout from '../components/layout/StaticPageLayout';
import { Card } from '../components/ui';
import Swal from 'sweetalert2';

const ResetPassword = () => {
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) validationErrors.email = 'Please enter an email.';
        else if (!emailRegex.test(email)) validationErrors.email = 'Please enter a valid email.';
        if (!newPassword) validationErrors.newPassword = 'Please enter a new password.';
        if (!confirmPassword) validationErrors.confirmPassword = 'Please confirm your new password.';
        if (newPassword !== confirmPassword) validationErrors.confirmPassword = 'Passwords do not match.';

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            Swal.fire({ icon: 'error', title: 'Please fix the following issues:', html: Object.values(validationErrors).join('<br>'), showCloseButton: true });
            return;
        }

        fetch(API_URL + '/reset-password', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, token, password: newPassword, password_confirmation: confirmPassword }),
        })
            .then((response) => {
                if (response.status === 200) {
                    Swal.fire({ icon: 'success', title: 'Password reset successful!', timer: 2000 });
                    navigate('/');
                } else if (response.status === 422) {
                    response.json().then((data) => {
                        const errorMessages = data.errors ? Object.values(data.errors).join('<br>') : data.message || 'An error occurred during password reset.';
                        Swal.fire({ icon: 'error', title: 'Password reset failed.', html: errorMessages, showCloseButton: true });
                    });
                }
            })
            .catch((error) => console.error('Error resetting password:', error));
    };

    const inputClasses = "tw-w-full tw-rounded-lg tw-border tw-border-gray-400 tw-bg-white tw-px-4 tw-py-3 tw-text-sm tw-text-gray-800 tw-placeholder-gray-400 tw-outline-none tw-transition-all focus:tw-border-primary-500 focus:tw-ring-2 focus:tw-ring-primary-100";

    return (
        <div style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
            <Header />
            <StaticPageLayout title="Reset Password" subtitle="Enter your email and choose a new password.">
                <Card variant="outlined" className="tw-max-w-md">
                    <form onSubmit={handleSubmit} className="tw-space-y-5">
                        <div className="tw-flex tw-flex-col tw-gap-1.5">
                            <label htmlFor="email" className="tw-text-sm tw-font-medium tw-text-gray-700">Email</label>
                            <div className="tw-relative">
                                <FontAwesomeIcon icon={faEnvelope} className="tw-absolute tw-left-3.5 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400" />
                                <input type="text" id="email" className={`${inputClasses} tw-pl-10`} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
                            </div>
                            {errors.email && <p className="tw-text-xs tw-text-error tw-m-0">{errors.email}</p>}
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-1.5">
                            <label htmlFor="newPassword" className="tw-text-sm tw-font-medium tw-text-gray-700">New Password</label>
                            <div className="tw-relative">
                                <FontAwesomeIcon icon={faLock} className="tw-absolute tw-left-3.5 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400" />
                                <input type="password" id="newPassword" className={`${inputClasses} tw-pl-10`} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="New Password" />
                            </div>
                            {errors.newPassword && <p className="tw-text-xs tw-text-error tw-m-0">{errors.newPassword}</p>}
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-1.5">
                            <label htmlFor="confirmPassword" className="tw-text-sm tw-font-medium tw-text-gray-700">Confirm Password</label>
                            <div className="tw-relative">
                                <FontAwesomeIcon icon={faLock} className="tw-absolute tw-left-3.5 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400" />
                                <input type="password" id="confirmPassword" className={`${inputClasses} tw-pl-10`} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm Password" />
                            </div>
                            {errors.confirmPassword && <p className="tw-text-xs tw-text-error tw-m-0">{errors.confirmPassword}</p>}
                        </div>
                        <button type="submit" className="tw-w-full tw-bg-accent-500 hover:tw-bg-accent-600 tw-text-white tw-px-6 tw-py-3 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-all tw-shadow-sm hover:tw-shadow-md tw-flex tw-items-center tw-justify-center tw-gap-2">
                            Reset Password <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </form>
                </Card>
            </StaticPageLayout>
            <PublicFooter />
        </div>
    );
};

export default ResetPassword;
